import { UPDATE_CLIENT } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_CLIENT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_CLIENT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPDATE_CLIENT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
